import {
    Box,
    FormControl,
    FormErrorMessage,
    FormLabel,
    Stack,
    Text,
    Switch,
    HStack,
    FormHelperText,
} from '@chakra-ui/react';
import { Field } from 'formik';
import { useState } from 'react';

import FieldToolTip from 'components/forms/new/FieldToolTip';
import {
    descriptionStyling,
    formLabelStyling,
    stackSpacing,
    stackStyling,
} from 'components/forms/new/formStyles';

const AuthenticationField = ({
    errors,
    values,
    touched,
    darkMode,
    isDisabled = false,
    validationError = { username: '', password: '' },
}) => {
    const [isHovered, setIsHovered] = useState(false);

    return (
        <FormControl
            sx={{
                margin: '0 !important',
                '& svg': {
                    mt: '8px!important',
                },
            }}
            isInvalid={
                !!errors.overrideCredentials && touched.overrideCredentials
            }
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}>
            <Stack
                direction="row"
                spacing={stackSpacing}
                sx={stackStyling(true)}>
                <Box>
                    <FormLabel sx={formLabelStyling(darkMode)}>
                        Authentication
                    </FormLabel>
                    <Text
                        sx={{
                            ...descriptionStyling,
                            color: darkMode ? 'gray.100' : '#757575',
                        }}
                        maxW={250}>
                        Authentication method
                    </Text>
                </Box>
                <Field name="overrideCredentials">
                    {({ field, form: { setFieldValue } }) => (
                        <Box
                            flex="1"
                            sx={{
                                paddingTop: '15px',
                                display: 'flex',
                                alignItems: 'center',
                            }}>
                            <HStack spacing={3} alignItems="center">
                                <Switch
                                    {...field}
                                    id="overrideCredentials"
                                    isChecked={!values?.overrideCredentials}
                                    isDisabled={isDisabled}
                                    onChange={(e) => {
                                        setFieldValue(
                                            'overrideCredentials',
                                            !e.target.checked,
                                        );
                                    }}
                                    size="md"
                                />
                                <Text
                                    className="!mb-2"
                                    fontSize="sm"
                                    color={darkMode ? 'gray.100' : 'gray.700'}
                                    fontWeight="semibold">
                                    Use{' '}
                                    {values?.overrideCredentials
                                        ? 'Username/Password'
                                        : 'Registrar'}
                                </Text>
                            </HStack>

                            {(errors?.overrideCredentials ||
                                validationError?.username ||
                                validationError?.password) && (
                                <FormErrorMessage fontSize="sm" mt={1}>
                                    {errors?.overrideCredentials ||
                                        validationError?.username ||
                                        validationError?.password}
                                </FormErrorMessage>
                            )}
                        </Box>
                    )}
                </Field>

                {isHovered && (
                    <FieldToolTip
                        label="Enable this option to use the registrar's authentication credentials. When disabled, you can provide custom username and password."
                        ariaLabel="authentication-tip"
                        left="25px"
                        top="25px"
                    />
                )}
            </Stack>

            {values.overrideCredentials && (
                <FormHelperText m="0 0 8px 333px">
                    Username and password are required when not using registrar
                </FormHelperText>
            )}
        </FormControl>
    );
};

export default AuthenticationField;
